export default "__VITE_ASSET__CfWn5X3n__"